import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';
import { saveItemFamilyPublished, publishItemFamily } from '../itemFamily/itemFamilySlice';

export const fetchItemFamilies = createAsyncThunk(
  'itemFamilies/get',
  async (data, thunkAPI) => {
    try {
      const response = await api.getItemFamilies(data.ownerId);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: itemFamilies/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  itemFamilies: [],
  status: 'idle',
  error: null
};


export const itemFamiliesSlice = createSlice({
  name: 'itemFamilies',
  initialState,
  reducers: {
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchItemFamilies.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.itemFamilies = action.payload.itemFamilies || [];
    },
    [fetchItemFamilies.pending]: (state, action) => {
      state.status = 'loading',
      state.error = null;
    },
    [fetchItemFamilies.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = {
        message: action.payload.messages.join(', ')
      };
    },

    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    },

    [saveItemFamilyPublished.fulfilled]: (state, action) => {
      // Update list when item family is saved (published version)
      const index = state.itemFamilies.findIndex(fam => fam.code === action.payload.code);
      state.itemFamilies[index] = action.payload;
    },

    [publishItemFamily.fulfilled]: (state, action) => {
      // Update list when item family is saved (published version)
      const index = state.itemFamilies.findIndex(fam => fam.code === action.payload.code);
      state.itemFamilies[index] = action.payload;
    },
  }
});

export const selectItemFamilies = state => state.itemFamilies;

export default itemFamiliesSlice.reducer;
